export const ENVIRONMENT: 'development' | 'production' | 'demo' = 'production'
export const REVISION: string = '587788854375a96dca53408b1e69b59fbe9949e1'



// WEBPACK FOOTER //
// ./src/config/environment.ts